import React from "react";
import { IconProps } from "../icon";
import { createIcon } from "../util/create-icon";
// import "../style/css";

const CartIcon: React.ForwardRefExoticComponent<
  IconProps & React.RefAttributes<SVGSVGElement>
> = /*#__PURE__*/ createIcon(
  "cart",
  "CartIcon",
  ["currentColor","white"],
  (colorList) => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none"><g clipPath="url(#clip0_19498_1244)"><path d="M0 0.666748H3.17586L3.5395 2.00008H15.5916L13.1472 9.33341H5.18718L4.85385 10.6667H14.6667V12.0001H3.14615L3.97765 8.67408L2.15747 2.00008H0V0.666748ZM5.17586 8.00008H12.1862L13.7417 3.33341H3.90314L5.17586 8.00008ZM2.66667 14.0001C2.66667 13.2637 3.26362 12.6667 4 12.6667C4.73638 12.6667 5.33333 13.2637 5.33333 14.0001C5.33333 14.7365 4.73638 15.3334 4 15.3334C3.26362 15.3334 2.66667 14.7365 2.66667 14.0001ZM12 14.0001C12 13.2637 12.597 12.6667 13.3333 12.6667C14.0697 12.6667 14.6667 13.2637 14.6667 14.0001C14.6667 14.7365 14.0697 15.3334 13.3333 15.3334C12.597 15.3334 12 14.7365 12 14.0001Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd" fillOpacity="0.9"/></g><defs><clipPath id="clip0_19498_1244"><rect width="16" height="16" fill={colorList[1]}/></clipPath></defs></g></svg>
);

export default CartIcon;
